import React from "react";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Chip } from "@material-ui/core";
import { makeThemedStyles } from "qpr-base/viewcomponents/utils";
import { ActionData } from "backend/hooks/actions/useActionsByKpiInitiative";
import { t } from "i18next";

const useStyles = makeThemedStyles("ActionsPreview", (theme) => ({
	table: {
		width: "100%",
		tableLayout: "fixed",
		"& .MuiPaper-root": {
			all: "unset",
		},
		"& .MuiTableCell-stickyHeader": {
			backgroundColor: "unset",
		},
		"& .MuiTableCell-head": {
			textTransform: "uppercase",
			fontSize: "10px",
			fontWeight: 600,
			color: "black",
			borderBottom: "2px solid #e0e0e0",
		},
		"& .MuiTableCell-root": {
			borderBottom: "1px solid #e0e0e0",
			verticalAlign: "middle",
		},
	},
	descriptionCell: {
		maxWidth: "300px",
		overflow: "hidden",
		textOverflow: "ellipsis",
		whiteSpace: "nowrap",
	},
	actionNameCell: {
		maxWidth: "250px",
		overflow: "hidden",
		textOverflow: "ellipsis",
		whiteSpace: "nowrap",
	},
	statusChip: {
		fontSize: "0.75rem",
		fontWeight: 600,
		height: "24px",
	},
}));

interface ActionsPreviewProps {
	actions: ActionData[];
	kpiInitiativeName?: string;
}

const ActionsPreview: React.FC<ActionsPreviewProps> = ({ actions, kpiInitiativeName }) => {
	const styles = useStyles();

	const getStatusColor = (status: string) => {
		switch (status?.toLowerCase()) {
			case "Completed":
				return "bg-green-500 text-white";

			case "Not Started":
				return "bg-gray-500 text-white";

			case "Delayed":
				return "bg-red-500 text-white";

			case "In Progress":
				return "bg-blue-500 text-white";

			default:
				return "bg-gray-400 text-white";
		}
	};

	const getStatusLabel = (status: string) => {
		console.log(status?.toLowerCase(), t("Actions.Not Started"))
		switch (status?.toLowerCase()) {
			case "completed": return t("Actions.Completed");
			case "delayed": return t("Actions.Delayed");
			case "not started": return t("Actions.Not Started");
			case "in progress": return t("Actions.In Progress");

			default: return status || t("Actions.Unknown");
		}
	};

	if (!actions || !Array.isArray(actions) || actions.length === 0) {
		return (
			<Paper style={{ padding: "32px", textAlign: "center", backgroundColor: "#f5f5f5", borderRadius: "8px" }}>
				<div style={{ color: "#666", fontSize: "16px" }}>
					{t("Actions.No actions yet")}
				</div>
			</Paper>
		);
	}

	return (
		<TableContainer component={Paper} className={styles.table}>
			<Table>
				<TableHead>
					<TableRow>
						<TableCell>{t("Actions.Action Name")}</TableCell>
						<TableCell>{t("Actions.Description")}</TableCell>
						<TableCell>{t("Actions.Assignees")}</TableCell>
						<TableCell>{t("Actions.Status")}</TableCell>
					</TableRow>
				</TableHead>
				<TableBody>
					{ actions.map((action, index) => (
						<TableRow key={action._id || action.id || index} hover>
							<TableCell className={styles.actionNameCell} title={action.actionName}>
								{action.actionName}
							</TableCell>
							<TableCell className={styles.descriptionCell} title={action.description}>
								{action.description || "-"}
							</TableCell>
							<TableCell>
								{action.assignToNames?.join(", ") || "-"}
							</TableCell>
							<TableCell>
								<Chip
									label={getStatusLabel(action.status)}
									size="small"
									className={styles.statusChip}
									color={getStatusColor(action.status) as any}
								/>
							</TableCell>
						</TableRow>
					))}
				</TableBody>
			</Table>
		</TableContainer>
	);
};

export default ActionsPreview;
